import React from 'react';
import { StyledGlobalStyles } from './style';

export const GlobalStyle: React.FC = () => <StyledGlobalStyles />;
